import React from 'react';
import './ScreenComposerNotifier.css';

const ScreenComposerNotifier = ({ isGenerating, progress, error, justCompleted, onDismiss, onCancel }) => {
  const visible = isGenerating || !!error || justCompleted;
  if (!visible) return null;

  const status = error ? 'error' : justCompleted ? 'success' : 'generating';

  return (
    <div className={`sc-bar-indicator ${status}`}>
      {status === 'generating' && (
        <div className="sc-bar-spinner" />
      )}
      {status === 'success' && (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      )}
      {status === 'error' && (
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2.5"/>
          <path d="M12 8v4" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
        </svg>
      )}
      <span className="sc-bar-label">
        {status === 'error' ? 'SC Error' :
         status === 'success' ? 'Ready' :
         progress === 'downloading' ? 'Saving...' :
         'Composing...'}
      </span>
      {status === 'generating' && onCancel && (
        <button className="sc-bar-cancel" onClick={onCancel} title="Cancel">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        </button>
      )}
      {status === 'error' && (
        <button className="sc-bar-cancel" onClick={onDismiss} title="Dismiss">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default ScreenComposerNotifier;
